'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _components = require('components');

var _moduleData = require('redux/modules/moduleData');

var moduleActions = _interopRequireWildcard(_moduleData);

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _modules = require('redux/modules/modules');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var YES = 'Yes';
var NO = 'No';
var ABLE_TRY_TRY_ONE = 'Able to try one strategy';
var MADE_AN_ATTEMPT = 'Made an attempt';

var MOSTLY_POSITIVE = 'Mostly positive';
var MOSTLY_NEGATIVE = 'Mostly negative';
var MIXED = 'Mixed';

var YES_WITH_DIFFICULTY = 'Yes with difficulty';
var DONT_NEED_HELP = 'I don\'t need help';

var Module4App1 = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    allModule: state.moduleData.data.module4,
    app: state.moduleData.data.module4.app1,
    profile: state.profile.data
  };
}, (0, _extends3.default)({}, moduleActions, { changeItem: _modules.changeItem })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module4App1, _Component);

  function Module4App1() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module4App1);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module4App1.__proto__ || (0, _getPrototypeOf2.default)(Module4App1)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      module: 'Module 4',
      title: 'Recap',
      moduleId: 4,
      appId: 1,
      isCompleted: false,
      ableToDiscuss: _this.props.app.ableToDiscuss || '', // were you able to try any of the strategies we discussed or you set?
      anyPositive: _this.props.app.anyPositive || '', // was there anything positive
      anyBarriers: _this.props.app.anyBarriers || '', // were there any barriers that made it difficult for you try these strategies
      additionalStrategies: _this.props.app.additionalStrategies || '', // are there any additional strategies that helped you overcome the barriers help you in future?
      barriersDifficult: _this.props.app.barriersDifficult || '',
      overcomeBarriers: _this.props.app.overcomeBarriers || ''
    }, _this.handleComplete = function () {
      var obj = _this.state;
      var numAppCompleted = _this.props.allModule.numAppCompleted;

      // if its not completed, we increase numAppCompleted
      if (!obj.isCompleted) {
        numAppCompleted++;
      }

      obj.isCompleted = true;
      _this.setState(obj);

      // update the actual app
      _this.props.updateModuleApp(_this.props.user.userId, _this.state.moduleId, _this.state.appId, _this.state);

      // update the overarching module's details
      // this.props.updateModule(this.props.user.userId, this.state.moduleId, {
      //   'numAppCompleted': numAppCompleted,
      //   'numAppTotal': this.props.allModule.numAppTotal});

      // this.props.changeItem(this.state.moduleId, 0, this.state.appId + 1);
    }, _this.handleAbleToDiscuss = function (event) {
      var obj = _this.state;
      obj.ableToDiscuss = event.target.value;
      obj.anyPositive = '';
      obj.anyBarriers = '';
      obj.additionalStrategies = '';
      obj.barriersDifficult = '';
      obj.overcomeBarriers = '';
      _this.setState(obj);
    }, _this.handleAnyPositive = function (event) {
      var obj = _this.state;
      obj.anyPositive = event.target.value;
      obj.anyBarriers = '';
      obj.additionalStrategies = '';
      obj.barriersDifficult = '';
      obj.overcomeBarriers = '';
      _this.setState(obj);
    }, _this.handleAnyBarriers = function (event) {
      var obj = _this.state;
      obj.anyBarriers = event.target.value;
      obj.additionalStrategies = '';
      obj.barriersDifficult = '';
      obj.overcomeBarriers = '';
      _this.setState(obj);
    }, _this.handleAnyAdditionalStrategies = function (event) {
      var obj = _this.state;
      obj.additionalStrategies = event.target.value;
      obj.barriersDifficult = '';
      obj.overcomeBarriers = '';
      _this.setState(obj);
    }, _this.handleChange = function (str, event) {
      var obj = _this.state;
      obj[str] = event.target.value;
      _this.setState(obj);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /*
   * Handle when user finishes this module
   */


  (0, _createClass3.default)(Module4App1, [{
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              this.state.module
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.state.title
            )
          ),
          _react2.default.createElement(
            ReactBootstrap.Row,
            null,
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 12, sm: 12, xs: 12 },
              _react2.default.createElement(
                'p',
                null,
                'In Module 3 we talked about things you could try at mealtimes to encourage ',
                this.props.profile.childName,
                ' to eat vegies. At the end of the module we asked you to set yourself some strategies to try.'
              ),
              _react2.default.createElement(
                'h5',
                null,
                'Were you able to try any of the strategies we discussed or that you set?'
              ),
              _react2.default.createElement(
                ReactBootstrap.FormGroup,
                { onChange: this.handleAbleToDiscuss.bind(this) },
                _react2.default.createElement(
                  ReactBootstrap.Radio,
                  { name: 'ableToDiscuss', value: YES, checked: this.state.ableToDiscuss === YES },
                  YES
                ),
                _react2.default.createElement(
                  ReactBootstrap.Radio,
                  { name: 'ableToDiscuss', value: ABLE_TRY_TRY_ONE, checked: this.state.ableToDiscuss === ABLE_TRY_TRY_ONE },
                  ABLE_TRY_TRY_ONE
                ),
                _react2.default.createElement(
                  ReactBootstrap.Radio,
                  { name: 'ableToDiscuss', value: MADE_AN_ATTEMPT, checked: this.state.ableToDiscuss === MADE_AN_ATTEMPT },
                  MADE_AN_ATTEMPT
                ),
                _react2.default.createElement(
                  ReactBootstrap.Radio,
                  { name: 'ableToDiscuss', value: NO, checked: this.state.ableToDiscuss === NO },
                  NO
                )
              ),
              this.state.ableToDiscuss !== NO && this.state.ableToDiscuss !== '' && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h5',
                  null,
                  'Was there anything positive?'
                ),
                _react2.default.createElement(
                  ReactBootstrap.FormGroup,
                  { onChange: this.handleAnyPositive.bind(this) },
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'anyPositive', value: MOSTLY_POSITIVE, checked: this.state.anyPositive === MOSTLY_POSITIVE },
                    MOSTLY_POSITIVE
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'anyPositive', value: MOSTLY_NEGATIVE, checked: this.state.anyPositive === MOSTLY_NEGATIVE },
                    MOSTLY_NEGATIVE
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'anyPositive', value: MIXED, checked: this.state.anyPositive === MIXED },
                    MIXED
                  )
                )
              ),
              (this.state.ableToDiscuss !== NO && this.state.ableToDiscuss !== '' && this.state.anyPositive || this.state.ableToDiscuss === NO) && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h5',
                  null,
                  'Were there any barriers that made it difficult for you to try these strategies?'
                ),
                _react2.default.createElement(
                  ReactBootstrap.FormGroup,
                  { onChange: this.handleAnyBarriers.bind(this) },
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'anyBarriers', value: NO, checked: this.state.anyBarriers === NO || this.state.anyBarriers == 0 },
                    'No/Don\'t know'
                  ),
                  (this.state.anyBarriers === NO || this.state.anyBarriers == 0) && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'p',
                      null,
                      'It\'s good that you feel like you\'ve got this under control and you know how to help ',
                      this.props.profile.childName,
                      ' eat the recommended amount of vegies every day.'
                    )
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'anyBarriers', value: YES, checked: this.state.anyBarriers === YES || this.state.anyBarriers == 1 },
                    YES
                  )
                )
              ),
              (this.state.anyBarriers === YES || this.state.anyBarriers == 1) && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h5',
                  null,
                  'Are there any additional stategies that helped you overcome the barriers or that you think will help you in the future?'
                ),
                _react2.default.createElement(
                  ReactBootstrap.FormGroup,
                  { onChange: this.handleAnyAdditionalStrategies.bind(this) },
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'additionalStrategies', value: NO, checked: this.state.additionalStrategies === NO },
                    'No/Don\'t know'
                  ),
                  this.state.additionalStrategies === NO && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'p',
                      null,
                      'Your situation sounds tricky. Think about these things and try to find a solution: '
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      'What was it that made it difficult to try this strategy?',
                      _react2.default.createElement('br', null),
                      'Is this likely to be barrier in the future?',
                      _react2.default.createElement('br', null),
                      'How have you got around this barrier in other situations?',
                      _react2.default.createElement('br', null),
                      'Have a look in the Reboot resources for strategies that might work.'
                    )
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'additionalStrategies', value: YES_WITH_DIFFICULTY, checked: this.state.additionalStrategies === YES_WITH_DIFFICULTY },
                    YES_WITH_DIFFICULTY
                  ),
                  this.state.additionalStrategies === YES_WITH_DIFFICULTY && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'p',
                      null,
                      'Your situation sounds tricky. Think about these things and try to find a solution: '
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      'What was it that made it difficult to try this strategy?',
                      _react2.default.createElement('br', null),
                      'Is this likely to be barrier in the future?',
                      _react2.default.createElement('br', null),
                      'How have you got around this barrier in other situations?',
                      _react2.default.createElement('br', null),
                      'Have a look in the Reboot resources for strategies that might work.'
                    )
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'additionalStrategies', value: YES, checked: this.state.additionalStrategies === YES },
                    YES
                  ),
                  this.state.additionalStrategies === YES && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'p',
                      null,
                      'That\'s great! You might like to try them this week or keep using them if you are already. Remember there is a lot of useful information in the Reboot resources.'
                    )
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'additionalStrategies', value: DONT_NEED_HELP, checked: this.state.additionalStrategies === DONT_NEED_HELP },
                    DONT_NEED_HELP
                  ),
                  this.state.additionalStrategies === DONT_NEED_HELP && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'p',
                      null,
                      'It\'s good that you feel like you\'ve got this under control and you know how to help ',
                      this.props.profile.childName,
                      ' eat the recommended amount of vegies every day.'
                    )
                  )
                )
              ),
              this.state.additionalStrategies && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h5',
                  null,
                  'What were the barriers which made it more difficult for you?'
                ),
                _react2.default.createElement(ReactBootstrap.FormControl, { componentClass: 'textarea', placeholder: 'What barriers made it difficult',
                  value: this.state.barriersDifficult, onChange: this.handleChange.bind(this, 'barriersDifficult') }),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                  'h5',
                  null,
                  'Is there anything you did (or could do) to help overcome these barriers?'
                ),
                _react2.default.createElement(ReactBootstrap.FormControl, { componentClass: 'textarea', placeholder: 'What barriers made it difficult',
                  value: this.state.overcomeBarriers,
                  onChange: this.handleChange.bind(this, 'overcomeBarriers') })
              )
            )
          ),
          _react2.default.createElement('div', { className: styles.spacer20 }),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete })
          )
        )
      );
    }
  }]);
  return Module4App1;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  allModule: _propTypes2.default.object,
  app: _propTypes2.default.object,
  updateModule: _propTypes2.default.func,
  updateModuleApp: _propTypes2.default.func,
  changeItem: _propTypes2.default.func,
  profile: _propTypes2.default.object
}, _temp2)) || _class);
exports.default = Module4App1;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/4/App/App1.js
// module id = 1205
// module chunks = 0